export default {
	"notice": {
		"createdDt": "เวลาจัดทำข้อความ",
		"readDt": "เวลาอ่านข้อความ",
		"unread": "ยังไม่ได้อ่าน"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/notice/notice.js